import styled from 'styled-components';

const ButtonSection = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const GroupBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-24);
  padding: var(--space-16);
`;

const GroupModel = styled.form``;

export { ButtonSection, GroupBody, GroupModel };
